
import { useEffect } from "react";
import { SEO } from "@/components/SEO";
import { AdvertiseHero } from "@/components/advertise/AdvertiseHero";
import { AdvertiseOpportunities } from "@/components/advertise/AdvertiseOpportunities";
import { AdvertiseBenefits } from "@/components/advertise/AdvertiseBenefits";
import { AdvertiseFAQ } from "@/components/advertise/AdvertiseFAQ";
import { AdvertiseForm } from "@/components/advertise/AdvertiseForm";

const AdvertiseWithUs = () => {
  // Scroll to the form when the URL has the #contact-form hash
  useEffect(() => {
    if (window.location.hash === "#contact-form") {
      const element = document.getElementById("contact-form");
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, []);

  return (
    <div className="min-h-screen">
      <SEO
        title="Advertise With Us | Home Pros OKC"
        description="Reach thousands of local homeowners in Oklahoma City. Place your ads on HomeProsOKC.com and connect with homeowners actively searching for services."
        canonicalUrl="/advertise-with-us"
      />
      <AdvertiseHero />
      <AdvertiseOpportunities />
      <AdvertiseBenefits />
      <AdvertiseFAQ />
      <AdvertiseForm />
    </div>
  );
};

export default AdvertiseWithUs;
